import React from 'react';
import {createRoot} from "react-dom/client";

import ProductDetailsContainer from "./Containers/ProductDetailsContainer";
import ContactMeContainer from "./Containers/ContactMeContainer";
import NotificationDetailsContainer from "./Containers/NotificationDetailsContainer";
import ProductGroupPriceInfoContainer from "./Containers/ProductGroupPriceInfoContainer";

const productDetails = document.getElementById('js-product-details-container');
if (productDetails) {
    const el = createRoot(productDetails);
    el.render(<ProductDetailsContainer {...(productDetails.dataset)} />);
}

const contactMe = document.getElementById('contact-me-container');
if (contactMe) {
    const el = createRoot(contactMe);
    el.render(<ContactMeContainer {...contactMe.dataset} />)
}
const notificationDetailsContainer = document.getElementById('notification-details-container');
if (notificationDetailsContainer) {
    const el = createRoot(notificationDetailsContainer);
    el.render(<NotificationDetailsContainer {...notificationDetailsContainer.dataset} />)
}

const productGroupPriceInfoContainer = document.getElementById('js-product-group-price-info-container');
if (productGroupPriceInfoContainer) {
    const el = createRoot(productGroupPriceInfoContainer);
    el.render(<ProductGroupPriceInfoContainer {...productGroupPriceInfoContainer.dataset} />)
}